/**
 * @fileoverview experiments config for switchboard A/B testing
 *
 * {@link https://globalrepository.mclocal.int/stash/projects/BERT/repos/switchboard/browse/README.md}
 */

/**
 * All experiment names
 *
 * @returns {Object}
 */
export const EXPERIMENTS = {}

/**
 * Events for logging in analytics
 *
 * @returns {Object}
 */
export const EXPERIMENT_LOG = {
  INVALID_EXPERIMENT_VARIANT: {
    event: 'INVALID_EXPERIMENT_VARIANT',
    message: 'Experiment variant was not recognized.'
  }
}

/**
 * All experiments
 *
 * @returns {Object}
 */
export const experiments = {}
